import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  Box,
  Heading,
  Text,
  Input,
  Button,
  Flex,
  FormControl,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  IconButton,
  Icon,
} from '@chakra-ui/react';

import { HiUpload } from 'react-icons/hi';
import { CloseIcon } from '@chakra-ui/icons';

import { useColors } from './colors';

import { downloadInventoryFileFormatApi } from 'features/suppliers/suppliers.api';

const InventoryUpload = ({
  inventoryFile,
  onFileChange,
  onClearFile,
  onUpload,
  isUploading,
  lastUploadDate,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { downloadInventoryFormatStatus } = useSelector((state) => state.suppliers);
  const { backgroundCardColor, textColor, secondaryTextColor } = useColors();

  const handleDownloadFormat = () => {
    dispatch(downloadInventoryFileFormatApi(id));
  };

  return (
    <Box p={6} bg={backgroundCardColor} borderRadius="lg" boxShadow="sm" h="300px">
      <Flex justify="space-between" align="center" mb={2}>
        <Heading size="lg" color={textColor}>
          Inventory Upload
        </Heading>
        <Button
          colorScheme="blue"
          size="md"
          onClick={handleDownloadFormat}
          isLoading={downloadInventoryFormatStatus === 'pending'}
          loadingText="Downloading..."
        >
          Download File Format
        </Button>
      </Flex>
      <Text fontSize="sm" color={secondaryTextColor} mb={6}>
        Last Inventory Upload Date: {lastUploadDate}
      </Text>
      <FormControl mb={4} maxW="50%">
        <InputGroup size="md">
          <InputLeftElement pointerEvents="none" h="full">
            <Icon as={HiUpload} color="gray.400" />
          </InputLeftElement>
          <Input
            type="file"
            pt={2}
            pl={10}
            accept=".csv,.xlsx,.txt"
            onChange={onFileChange}
            color={textColor}
            value={inventoryFile ? '' : undefined}
            sx={{
              '::file-selector-button': {
                display: 'none',
              },
              '&::placeholder': {
                color: textColor,
              },
            }}
            cursor="pointer"
            _placeholder={{ color: textColor }}
          />
          {inventoryFile && (
            <InputRightElement>
              <IconButton
                icon={<CloseIcon />}
                size="sm"
                variant="ghost"
                colorScheme="red"
                onClick={onClearFile}
                aria-label="Clear file"
              />
            </InputRightElement>
          )}
        </InputGroup>
        {inventoryFile && (
          <Text fontSize="sm" color={textColor} mt={1}>
            {inventoryFile.name}
          </Text>
        )}
      </FormControl>
      {inventoryFile && (
        <Flex justify="flex-end">
          <Button
            colorScheme="blue"
            size="md"
            w="200px"
            onClick={onUpload}
            isLoading={isUploading}
            loadingText="Uploading..."
          >
            Upload
          </Button>
        </Flex>
      )}
    </Box>
  );
};

export default InventoryUpload;
